import React from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  isMobile?: boolean;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ isMobile = false }) => {
  const { i18n, t } = useTranslation('common');

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    // Force reload service cache when language changes
    localStorage.removeItem('service_data_cache');
  };

  const currentLanguage = i18n.language;

  if (isMobile) {
    // Mobile version - full width buttons
    return (
      <div className="pt-3 mt-3 border-t border-[#E8F0F0]">
        <div className="text-xs font-medium text-[#3A5E63] mb-2 uppercase tracking-wider">
          {t('language.selectLanguage')}
        </div>
        <div className="flex flex-col space-y-2">
          <button
            onClick={() => changeLanguage('en')}
            className={`px-4 py-2 rounded text-sm font-medium transition-colors ${
              currentLanguage === 'en'
                ? 'bg-[#3A5E63] text-white'
                : 'bg-[#F3F3F3] text-[#3A5E63] hover:bg-[#E8F0F0]'
            }`}
          >
            {t('language.english')}
          </button>
          <button
            onClick={() => changeLanguage('es')}
            className={`px-4 py-2 rounded text-sm font-medium transition-colors ${
              currentLanguage === 'es'
                ? 'bg-[#3A5E63] text-white'
                : 'bg-[#F3F3F3] text-[#3A5E63] hover:bg-[#E8F0F0]'
            }`}
          >
            {t('language.spanish')}
          </button>
        </div>
      </div>
    );
  }

  // Desktop version - compact toggle
  return (
    <div className="flex items-center space-x-2 ml-4">
      <button
        onClick={() => changeLanguage('en')}
        className={`px-3 py-1.5 rounded text-sm font-medium transition-colors ${
          currentLanguage === 'en'
            ? 'bg-[#3A5E63] text-white'
            : 'bg-transparent text-[#3A5E63] hover:bg-[#E8F0F0]'
        }`}
        aria-label="Switch to English"
      >
        EN
      </button>
      <span className="text-[#3A5E63]">|</span>
      <button
        onClick={() => changeLanguage('es')}
        className={`px-3 py-1.5 rounded text-sm font-medium transition-colors ${
          currentLanguage === 'es'
            ? 'bg-[#3A5E63] text-white'
            : 'bg-transparent text-[#3A5E63] hover:bg-[#E8F0F0]'
        }`}
        aria-label="Cambiar a Español"
      >
        ES
      </button>
    </div>
  );
};

export default LanguageSwitcher;

